import {getApp, getApps, initializeApp} from 'firebase/app'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyB-jAubMSWhgX_QT7KanUcZCxRzHmCL9l0",
    authDomain: "restaurantapp-74296.firebaseapp.com",
    databaseURL: "https://restaurantapp-74296-default-rtdb.firebaseio.com",
    projectId: "restaurantapp-74296",
    storageBucket: "restaurantapp-74296.appspot.com",
    messagingSenderId: "497930223949",
    appId: "1:497930223949:web:d90057ab6d64a8102b7704"
  };

  const app= getApp.length > 0 ? getApp() : initializeApp(firebaseConfig);

  const firestore = getFirestore(app)
  const storage = getStorage(app)

  export {app, firestore, storage};